import React from 'react';
import './CheckboxListContainer.scss';
export default function CheckboxList({ options, onChange, label, value }) {
    const onCheck = (valueChecked) => {
        onChange(valueChecked);
    };
    return (React.createElement("div", { className: "checkboxListContainer" },
        React.createElement("label", { className: "qmb-label" }, label),
        React.createElement("ul", { key: "container" }, options.map((option) => (React.createElement("li", { key: option.value },
            React.createElement("label", { className: "qmb-checkbox" },
                React.createElement("input", { type: "checkbox", checked: value.includes(option.value), onChange: () => onCheck(option.value) }),
                React.createElement("p", { className: "qmb-checkbox-label", style: { padding: 0 }, onClick: (e) => {
                        e.preventDefault();
                        onCheck(option.value);
                    } },
                    React.createElement("span", { className: "qmb-checkbox-title" }, option.title)))))))));
}
